<div class="admin">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="breadcrumbs">
          <ul>
            <li>
              <a routerLink="/dashboard">
                Inicio
              </a>
            </li>
            <li>
              <a routerLink="../">
                Solicitar
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12" style="padding-bottom: 20px;">
        <h2 class="txt txt--title" *ngIf="requestType === 'third'">Nueva solicitud para un empleado o contratista</h2>
        <h2 class="txt txt--title" *ngIf="requestType === 'personal'">Nueva solicitud de licencia personal</h2>
        <small *ngIf="requestType === 'third'">A través del siguiente formulario podrás solicitar una nueva licencia
          para un empleado o
          contratista.</small>
        <small *ngIf="requestType === 'personal'">A través del siguiente formulario podrás solicitar una nueva licencia
          para ti.</small>
      </div>
      <div class="col-md-12 u-mt20" *ngIf="!(gettingPerson || selectedPersonData)  && requestType === 'third'">
        <div class="box u-mb60">
          <div class="row">
            <div class="col-lg-8">
              <app-select-list title="Persona a quien se solicita licencia"
                hintText="*El rut debe ser sin puntos y con guión"
                (textInputValueEmitter)="onSearchPersonTextChange($event)" [optionList]="listPersonOptions"
                placeHolder="Buscar por nombre, rut* o email" (selectedValueEmitter)="onSearchPersonSelected($event)"
                [isLoading]="loadingPersonOptions"
              >
              </app-select-list>
            </div>
            <div class="col-lg-3 offset-lg-1">
              <button type="button" class="btn btn--primary btn--big u-mt20" (click)="onSelectPerson()"
                [ngClass]="personForm.controls.id.value > 0 ? '' : 'btn--disabled'">Buscar persona</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 u-mb60" *ngIf="requestType === 'third' ? (gettingPerson || selectedPersonData) : true">
        <h2 class="txt txt--section u-mt40" *ngIf="requestType === 'personal'">
          {{titleNum+1}}. Información personal
        </h2>
        <app-person-card [personData]="selectedPersonData || {}" [boxColor]="personBoxColor"></app-person-card>
        <span class="back back--small u-mt10 global-hand" (click)="onUnselectDriver()" *ngIf="requestType === 'third'">
          Buscar otro conductor
        </span>
      </div>
    </div>
    <div class="" [ngClass]="{'u-lock': !selectedPersonData }">
      <app-form-asset-contract
        [controlForm]="licenseInformationForm"
        numberSection="1"
      >
      </app-form-asset-contract>
    </div>

    <div
      class="u-bt u-bt--grey u-pt30 u-mt20"
      [ngClass]="{'u-lock': this.licenseInformationForm.invalid || !selectedPersonData}"
    >
      <div class="row">
        <div class="col-md-12">
          <h2 class="txt txt--section">
            {{titleNum+3}}. Registro equipo(s)
          </h2>
          <h3 class="txt txt--paragraph u-mb30">
            Selecciona los campos asosiados al equipo(s) que quieres registrar.
          </h3>
        </div>
      </div>
      <form>
        <div class="box">
          <app-equipment
            [conductionZones]="zonesData"
            [vehicleTypes]="vehicleTypesData"
            [bannedVehicleTypes]="bannedVehicleTypeIds"
            [licenseTypes]="licenseTypesData"
            selectedOption="EQUIPMENT"
            [assetName]="this.licenseInformationForm.controls.assetId.value == 1 ? 'MEL' : 'SPC'"
            (addEquipment)="onSaveEquipment($event)"
          >
          </app-equipment>
          <div class="u-bt u-bt--grey u-pt30" style="margin-top: 15px">
            <div class="vehicles">
              <h3 class="txt txt--section u-mb20">
                Equipos ingresados
              </h3>
              <div class="vehicles__item vehicles__item--head">
                <div class="row">
                  <div class="col-1">
                    Nº
                  </div>
                  <div class="col-10">
                    <div class="row">
                      <div class="col-lg-3">
                        Tipo de equipo
                      </div>
                      <div class="col-lg-2 d-none d-lg-block">
                        Marca
                      </div>
                      <div class="col-lg-2 d-none d-lg-block">
                        Modelo
                      </div>
                      <div class="col-lg-3">
                        Tipo de licencia
                      </div>
                      <div class="col-lg-2">
                        Área de conducción
                      </div>
                    </div>
                  </div>
                  <div class="col-1">
                  </div>
                </div>
              </div>
              <div *ngIf="equipmentToShow.length > 0">
                <div class="vehicles__item" *ngFor="let item of equipmentToShow; index as i;">
                  <div class="row vehicle-rows">
                    <div class="col-1">
                      {{i+1}}
                    </div>
                    <div class="col-10">
                      <div class="row">
                        <div class="col-lg-3">
                          {{item.name}}
                        </div>
                        <div class="col-lg-2 d-none d-lg-block">
                          {{item.equipmentBrand}}
                        </div>
                        <div class="col-lg-2 d-none d-lg-block">
                          {{item.equipmentModel}}
                        </div>
                        <div class="col-lg-3">
                          {{ item.licenseTypes | separatedByCharacter: [', ', ' y '] }}
                        </div>
                        <div class="col-lg-2">
                          {{item.conductionZones | separatedByCharacter: ['/ ']}}
                        </div>
                      </div>
                    </div>
                    <div class="col-1">
                      <a (click)="onRemoveEquipment(i)"></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="u-bb u-bb--lightgrey u-mb20 u-pt20 u-pb20 txt txt--paragraph txt--grey"
              *ngIf="equipmentToShow.length === 0">
              No hay datos ingresados
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Divider -->
    <div class="u-bt u-bt--grey" style="margin: 40px 0;">
    </div>
    <!-- Divider -->

    <div [ngClass]="{'u-lock': equipmentToShow.length <= 0 && equipmentToSend.length <= 0 }">
      <app-documents-load
          *ngIf="selectedPersonData && this.requirementId"
          [documentFormArray]="documentFormArray"
          [requirementId]="this.requirementId"
          [equipmentDataToSend]="requestDocuments"
          [assetId]="this.licenseInformationForm.controls.assetId.value"
          [driverMdmId]="selectedPersonData.mdmid"
          [canReuseOldDocuments]="false"
          [numberSection]="(titleNum+4).toString()"
          [driverIsEmployee]="selectedPersonIsEmployee"
        >
      </app-documents-load>

      <!-- Divider -->
      <div class="u-bt u-bt--grey" style="margin: 40px 0 10px 0;">
      </div>
      <!-- Divider -->
      <app-form-employee
        *ngIf="selectedPersonIsEmployee"
        [assetId]="this.licenseInformationForm.value.assetId"
        [enabled]="formOk"
        [controlForm]="formEmployeeControl"
        [numberSection]="(titleNum+5).toString()"
        [isEmployee]="selectedPersonIsEmployee"
      >
      </app-form-employee>
      <app-form-contract-owner-selector
        *ngIf="!selectedPersonIsEmployee"
        [enabled]="formOk"
        [numberSection]="titleNum+5"
        (personSelected)="onSetContractOwner($event)"
      >
      </app-form-contract-owner-selector>

      <div class="u-bt u-bt--grey" style="z-index: 1;"></div>
      <div class="request__send u-pt20"
        [ngClass]="{'u-lock': selectedPersonIsEmployee ? !formOk : equipmentToShow.length <= 0 && equipmentToSend.length <= 0}">
        <div class="form">
          <div class="form__check">
            <input type="checkbox" name="checkbox" value="agree-terms" id="agree-terms" [formControl]="agreeTerms">
            <label for="agree-terms" >
              <div class="fakebox fakebox--grey"></div>
              <span>&nbsp;</span>
            </label>
            <span class="spanTerm-aconditions">
              Confirmo que he leído los <a (click)="showModalConfirmTermsAndConditions()" class="no-padding hover-hand"
                data-modal="modal01">términos y
                condiciones</a> y doy fe de la veracidad de los documentos ingresados para evitar sanciones asociadas.
            </span>
          </div>

        </div>
        <div class="buttons u-mt20">
          <div class="row">
            <div class="col-md-3 order-md-1 order-2">
              <a class="btn btn--link" (click)="showCancelModal()">Cancelar solicitud</a>
            </div>
            <div class="col-md-9 order-md-2 order-1">
              <button type="button" class="btn btn--primary modal__trigger" (click)="showConfirmationModal()"
                [attr.disabled]="!shouldActivateSubmit ? true : null">Enviar
                formulario
              </button>
            </div>

          </div>
          <div class="textWarningFillDocumentContainer">
            <p class="textWarningFillDocument">
              {{ !shouldActivateSubmit ? 'Para enviar el formulario debe completar todos los campos requeridos.' : ' '}}
              &nbsp;
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
